module.exports = __webpack_public_path__ + "img/rooms2Text.18f92660.png";